import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import GridTutorialCard from './GridTutorialCard';
import SearchBar from './SearchBar';
import StudentTutorialAPIs from 'utilities/api/StudentTutorialAPIs';
import nodatafoundImage from '../../../utilities/dummy_assets/nodatafound.jpg';
import { useSelector } from 'react-redux';
import QuizPage from '../quiz/QuizPage';

const TutorialContent = () => {
  const { user } = useSelector((state) => state.user);
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeQuiz, setActiveQuiz] = useState(null);
  // activeQuiz = { quizzes: [], moduleName: '' } | null

  useEffect(() => {
    const fetchData = async () => {
      try {
        const moduleList = await StudentTutorialAPIs.ModuleListGet();
        setData(moduleList.reverse());
      } catch (error) {
        console.error('Failed to fetch module list:', error);
      }
    };
    fetchData();
  }, [user]);

  const handleSearchQueryChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredData = data.filter((item) => {
    const name = item.name?.toLowerCase() || '';
    const description = item.description?.toLowerCase() || '';
    const query = searchQuery.toLowerCase();
    return name.includes(query) || description.includes(query);
  });

  // Full screen quiz takeover — replaces entire content area
  if (activeQuiz) {
    return (
      <QuizPage
        quizzes={activeQuiz.quizzes}
        moduleName={activeQuiz.moduleName}
        onBack={() => setActiveQuiz(null)}
      />
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <SearchBar
        searchQuery={searchQuery}
        handleSearchQueryChange={handleSearchQueryChange}
      />

      {filteredData.length > 0 ? (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'repeat(1, 1fr)',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(3, 1fr)',
              lg: 'repeat(4, 1fr)',
            },
            gap: '20px',
          }}
        >
          {filteredData.map((item) => (
            <GridTutorialCard
              key={item.id}
              item={item}
              onQuizOpen={(quizzes, moduleName) =>
                setActiveQuiz({ quizzes, moduleName })
              }
            />
          ))}
        </Box>
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          flexGrow={1}
          padding="40px"
        >
          <img
            src={nodatafoundImage}
            alt="No Data Found"
            style={{ width: '300px', marginBottom: '16px' }}
          />
          <Typography variant="h6" color="textSecondary">
            No modules found
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default TutorialContent;